export default __webpack_public_path__ + "static/media/dwaraka.cdc270c6.png";